import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"]

  update(event) {
    const file = event.target.files?.[0]
    if (!file) return

    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = URL.createObjectURL(file)

    this.previewTarget.innerHTML = ""
    const img = document.createElement("img")
    img.src = this.objectUrl
    img.className = "w-full h-full object-cover"
    this.previewTarget.appendChild(img)
  }

  disconnect() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
  }
}
